<route lang="yaml">
name: home
meta:
  title: 主页
  icon: ant-design:home-twotone
</route>

<script setup>
import welfareIndex from './component/welfare_index.vue'
import creationCampIndex from './component/creation_camp_index.vue'
import regimentalCommanderIndex from './component/regimental_commander_index.vue'
import mainBusinessIndex from './component/main_business_index.vue'
import useUserStore from '@/store/modules/user'

const userStore = useUserStore()
if(userStore.business == 0)
{
  userStore.business = localStorage.getItem('merchant_type')
}
function open(url) {
  window.open(url, '_blank')
}
</script>

<template>
  <div>
    <PageHeader>
      <template #title>
        <div class="flex items-center gap-4">
          欢迎使用 商家中心 {{ userStore.business }}
        </div>
      </template>
      <HButton
        v-if="userStore.business == '2'"
        outline
        @click="
          open(
            'https://gzpgymcn.feishu.cn/docx/X5qwds7hyoxyPOx3GVacEbSvnhd?from=from_copylink',
          )
        "
      >
        <SvgIcon name="i-ri:file-text-line" />
        指引文档
      </HButton>
      <HButton
        v-if="userStore.business == '4'"
        outline
        @click="
          open(
            'https://gzpgymcn.feishu.cn/wiki/AB9ZwkMiFie3LfksIBScRVzCnCc?from=from_copylink',
          )
        "
      >
        <SvgIcon name="i-ri:file-text-line" />
        指引文档
      </HButton>
    </PageHeader>

    <Auth value="Welfare">
      <welfareIndex v-if="userStore.business == '2'"/>
    </Auth>
    <Auth value="CreationCamp">
      <creationCampIndex v-if="userStore.business == '4'"/>
    </Auth>
    <Auth value="RegimentalCommander">
      <regimentalCommanderIndex v-if="userStore.business == '3'"/>
    </Auth>
    <Auth value="MainBusiness">
      <mainBusinessIndex v-if="userStore.business == '6'"/>
    </Auth>
    
  </div>
</template>

<style scoped>
.text-emphasis {
  text-emphasis-style: "❤";
}

.ecology {
  --uno: flex-1 m-0;

  :deep(.title-container) {
    --uno: flex items-center justify-between flex-wrap gap-4;

    .title-info {
      --uno: flex items-center gap-4;

      img {
        --uno: block w-12 h-12;
      }

      h1 {
        --uno: m-0 text-2xl;
      }

      h2 {
        --uno: m-0 text-base text-stone-5 font-normal;
      }
    }
  }
}
</style>
